import { UserTypes } from './user.reducer';

export const BadgesTypes = {
  SET_DISCREPANCY_COUNT: 'BADGES_SET_DISCREPANCY_COUNT',
  SET_PENDING_EXECUTIONS_COUNT: 'BADGES_SET_PENDING_EXECUTIONS_COUNT',
  CLEAR_BADGES: 'BADGES_CLEAR_BADGES',
};

export const setDiscrepancyCount = (count: number) => {
  return {
    type: BadgesTypes.SET_DISCREPANCY_COUNT,
    data: {
      discrepancyCount: count,
      discrepancyCountLastUpdate: new Date().toISOString(),
    },
  };
};

export const setPendingExecutionsCount = (count: number) => {
  return {
    type: BadgesTypes.SET_PENDING_EXECUTIONS_COUNT,
    data: {
      pendingExecutionsCount: count,
      pendingExecutionsCountLastUpdate: new Date().toISOString(),
    },
  };
};

export const clearBadges = () => {
  return {
    type: BadgesTypes.CLEAR_BADGES,
  };
};

export type BadgesState = {
  discrepancyCount: number;
  discrepancyCountLastUpdate: string | null;
  pendingExecutionsCount: number;
  pendingExecutionsCountLastUpdate: string | null;
};

const badgesInitialState: BadgesState = {
  discrepancyCount: 0,
  discrepancyCountLastUpdate: null,
  pendingExecutionsCount: 0,
  pendingExecutionsCountLastUpdate: null,
};

export type BadgesAction = {
  type: string;
  data?: {
    discrepancyCount?: number;
    discrepancyCountLastUpdate?: string;
    pendingExecutionsCount?: number;
    pendingExecutionsCountLastUpdate?: string;
  };
};

const badgesReducer = (state = badgesInitialState, action: BadgesAction): BadgesState => {
  switch (action.type) {
    case BadgesTypes.SET_DISCREPANCY_COUNT:
      return {
        ...state,
        discrepancyCount: action.data?.discrepancyCount ?? 0,
        discrepancyCountLastUpdate: action.data?.discrepancyCountLastUpdate ?? new Date().toISOString(),
      };

    case BadgesTypes.SET_PENDING_EXECUTIONS_COUNT:
      return {
        ...state,
        pendingExecutionsCount: action.data?.pendingExecutionsCount ?? 0,
        pendingExecutionsCountLastUpdate: action.data?.pendingExecutionsCountLastUpdate ?? new Date().toISOString(),
      };

    case BadgesTypes.CLEAR_BADGES:
    case UserTypes.LOGOUT_USER:
      return {
        ...badgesInitialState,
      };

    default:
      return state;
  }
};

export default badgesReducer;
